import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import { HttpParams } from '@angular/common/http';
import { convertTimeZoneMinus } from '@app/shared/utils';
import { Observable } from 'rxjs';
import {
  IParceiro,
  ParceiroEventoSaldoCredito,
  ParceiroEventoSaldoCreditoResult
} from '../model';

@Injectable()
export class ParceiroService<
  T extends IParceiro = IParceiro
> extends EntityService<T> {
  constructor(protected configService: ConfigService) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'parceiro'
    });
  }

  /**
   * Responsável por enviar um evento de atualização do limite de credito
   * @param cliente_id
   * @param evento
   * @returns
   */
  atualizarSaldoDeCredito(
    parceiro_id: string,
    evento: ParceiroEventoSaldoCredito
  ) {
    const url = `${this.baseURL}/${parceiro_id}/reg_parceiro_saldo_credito_evento`;
    return this.http.put<{ evento: ParceiroEventoSaldoCreditoResult }>(
      url,
      evento,
      {
        headers: this.getHeader()
      }
    );
  }

  /**
   * Responsável por gerar o XLSX do relatório de mov por parceiro
   * @returns
   */
  getExportData(where: any, entity_id: string): Observable<any> {
    var url = `${this.baseURL}/${entity_id}/relatorio_movimentacao_parceiro_xlsx`;
    var paramsHttp = new HttpParams();

    const today = convertTimeZoneMinus(new Date());
    // var dataSolicitacao = convertDateToMaskTimezone(
    //   `${today.getFullYear()}-${today.getUTCMonth() + 1}-${today.getDate()}`
    // );
    where['data_solicitacao'] = today.toISOString();

    return this.http.post(url, where, {
      headers: this.getHeader(),
      responseType: 'blob',
      params: paramsHttp
    });
  }
}
